module.exports = __webpack_public_path__ + "static/img/img-3.adde997.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/img-3.png
// module id = bJ6d
// module chunks = 63